import z from "zod";
export const DTOKnowledgeSkill = z.object({
    id: z.string(),
    workspaceId: z.string(),
    createdByUserId: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
    contentUpdatedAt: z.string(),
    path: z.string(),
    name: z.string(),
    description: z.string(),
    content: z.string(),
});
const DTOKnowledgeSkillWritableFields = z.object({
    path: z.string(),
    content: z.string(),
});
export const DTOKnowledgeSkillCreatePayload = DTOKnowledgeSkillWritableFields;
export const DTOKnowledgeSkillUpdatePayload = DTOKnowledgeSkillWritableFields.partial();
export const DTOKnowledgeSkillDeletePayload = z.object({
    id: z.union([z.string(), z.array(z.string())]),
});
export const DTOKnowledgeSkillListResponse = z.object({
    skills: z.array(DTOKnowledgeSkill),
});
export const DTOKnowledgeSkillResponse = z.object({
    skill: DTOKnowledgeSkill,
});
export const DTOKnowledgeSkillDeleteResponse = z.object({
    deletedIds: z.array(z.string()),
});
